module.exports = "https://cdn.thelire.com/ins/resource/coins_not_enough.a52edf1cc2ccc60dac3b1f406ca20a46.png";